import { queryClient } from '@/lib/queryClient';
import { queryKeys } from '@/lib/queryKeys';
import type { FeatureFlag, FeatureFlagName } from '@/types/featureFlags';

export function getFeatureFlags(organizationSlug: string): FeatureFlag[] {
  return queryClient.getQueryData<FeatureFlag[]>(queryKeys.featureFlags(organizationSlug)) ?? [];
}

export function isFeatureEnabled(
  organizationSlug: string,
  featureName: FeatureFlagName,
): boolean {
  const flag = getFeatureFlags(organizationSlug).find((f) => f.featureName === featureName);
  return flag?.isEnabled ?? false;
}
